__turbopack_context__.v({
  "backgroundDarkBlue": "HowItWorksV2-module__ml44mq__backgroundDarkBlue",
  "bottomWave": "HowItWorksV2-module__ml44mq__bottomWave",
  "bottomWaveDesktop": "HowItWorksV2-module__ml44mq__bottomWaveDesktop",
  "bottomWaveMobile": "HowItWorksV2-module__ml44mq__bottomWaveMobile",
  "buttonContainer": "HowItWorksV2-module__ml44mq__buttonContainer",
  "headingContainer": "HowItWorksV2-module__ml44mq__headingContainer",
  "headingText": "HowItWorksV2-module__ml44mq__headingText",
  "howItWorks": "HowItWorksV2-module__ml44mq__howItWorks",
  "innerStep": "HowItWorksV2-module__ml44mq__innerStep",
  "introHeading": "HowItWorksV2-module__ml44mq__introHeading",
  "prizesPopUp": "HowItWorksV2-module__ml44mq__prizesPopUp",
  "step": "HowItWorksV2-module__ml44mq__step",
  "stepDescription": "HowItWorksV2-module__ml44mq__stepDescription",
  "stepImage": "HowItWorksV2-module__ml44mq__stepImage",
  "stepText": "HowItWorksV2-module__ml44mq__stepText",
  "stepTitle": "HowItWorksV2-module__ml44mq__stepTitle",
  "stepsWrapper": "HowItWorksV2-module__ml44mq__stepsWrapper",
  "topWave": "HowItWorksV2-module__ml44mq__topWave",
  "topWaveDesktop": "HowItWorksV2-module__ml44mq__topWaveDesktop",
  "topWaveMobile": "HowItWorksV2-module__ml44mq__topWaveMobile",
});
